"use strict";

import Common from "../Common";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function InkPot() {
    // Constants.
    this.MIN_RADIUS = 5;
    this.MAX_RADIUS = 20;


    // Attributes.
    this._drawLayer = null;
    this._colour = null;
}
export default InkPot;
//module.exports               	= InkPot;
InkPot.prototype.constructor = InkPot;


//===================================================
//
// Public
//
//===================================================

InkPot.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._colour = Common.assets.getJSON("config").palettePanel.pages[0][0];

    // Signals.
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};


//===================================================
//
// Private
//
//===================================================

InkPot.prototype._draw = function (from, to) {
    this._drawLayer.context.beginPath();
    this._drawLayer.context.globalAlpha = Math.random() * 0.25 + 0.15;
    this._drawLayer.context.arc(
        to.x, to.y, Common.randomInt(this.MIN_RADIUS, this.MAX_RADIUS), false, Math.PI * 2, false);
    this._drawLayer.context.fill();

    this._drawLayer.onContext_Changed();
};


//===================================================
//
// Events
//
//===================================================

InkPot.prototype.onDrawBegan = function (point) {
    this._drawLayer.context.save();

    this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
    this._drawLayer.context.fillStyle = this._colour;

    this._draw(point, point);

    // Sfx.
    Common.audio.playSound("sfx_tool_inkpot_use_splat_00");
};

InkPot.prototype.onDrawMoved = function (from, to) {
    this._draw(from, to);
};

InkPot.prototype.onDrawEnded = function () {
    this._drawLayer.context.restore();
};

InkPot.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0)
        this._colour = selection;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    InkPot.prototype,
    "paletteItem",
    {
        get: function () {
            return this._colour;
        }
    });